module.exports = __webpack_public_path__ + "img/order_overview.46db2099.svg";